import auth from './auth'
import customerService from './odin/customer'
import dashboardService from './odin/dashboard'
import incidentsService from './odin/incidents'
import mssUserService from './odin/mssUser'
import requestsService from './odin/requests'
import siemCorrelationService from './odin/siemCorrelationRule'
import siemManagementService from './odin/siemManagement'
import userService from './odin/users'
import utilsService from './utils'
import dashboardExecutiveService from './odin/dashboardExecutive'
import lokiService from './loki'
import playbookService from './odin/playbook'
import mitreService from './odin/mitre'
import rulesDocumentationService from './odin/rulesDocumentation'
import swagger from './swagger'

export default {
  ...auth,
  ...customerService,
  ...dashboardService,
  ...incidentsService,
  ...mssUserService,
  ...requestsService,
  ...siemCorrelationService,
  ...siemManagementService,
  ...userService,
  ...utilsService,
  ...dashboardExecutiveService,
  ...lokiService,
  ...playbookService,
  ...rulesDocumentationService,
  ...mitreService,
  ...swagger
}
